import { useState } from 'react'
import { FieldMetaDialog, MetadataForm } from './FieldMetaDialog'

type FieldMetaDiologProps = {
  resourceId?: string
  onSuccess?: (result: MetadataForm) => void
}

export const useFieldMetaDialog = () => {
  const [dialogState, setDialogState] = useState<
    FieldMetaDiologProps & {
      open: boolean
    }
  >({
    open: false,
  })

  return {
    openFieldMetaDialog: (props: FieldMetaDiologProps) => setDialogState({ open: true, ...props }),
    fieldMetaDialog: (
      <FieldMetaDialog
        open={dialogState.open}
        resourceId={dialogState.resourceId}
        onClose={() => setDialogState({ open: false })}
        onCancel={() => setDialogState({ open: false })}
        onSuccess={(result: MetadataForm) => {
          setDialogState({ open: false })
          dialogState.onSuccess && dialogState.onSuccess(result)
        }}
      />
    ),
  }
}

export type UseFieldMetaDialog = ReturnType<typeof useFieldMetaDialog>
